// Persistent danger banner shown across every signed-in page when the
// org has at least one triggered (un-acknowledged) incident. Renders
// nothing when the queue is clean — silence is the default state.
//
// Behaviour:
//   - Sticks below the header so it can't scroll off-screen
//   - Pulsing red dot draws the eye without rotating background colours
//   - Singular incident → deep link straight to that incident
//   - Plural → /incidents pre-filtered to triggered

import { Link } from 'react-router-dom';
import { AlertTriangle, ArrowRight } from 'lucide-react';
import { useOpenIncidents } from '../../hooks/useOpenIncidents';

export function OpenIncidentsBanner() {
  const { triggered, topTriggered } = useOpenIncidents();
  if (triggered === 0) return null;

  const singular = triggered === 1 && topTriggered;
  const href = singular ? `/incidents/${topTriggered.id}` : '/incidents';
  const countLabel = singular
    ? '1 incident needs attention'
    : `${triggered} incidents need attention`;

  return (
    <Link to={href} className="ds-incident-banner" role="alert">
      <span className="ds-incident-banner__pulse" aria-hidden />
      <AlertTriangle size={16} strokeWidth={2} />
      <span className="ds-incident-banner__count">{countLabel}</span>
      {singular && (
        <span className="ds-incident-banner__title" title={topTriggered.title}>
          · {topTriggered.title}
        </span>
      )}
      <span className="ds-incident-banner__cta">
        {singular ? 'Open' : 'View all'}
        <ArrowRight size={14} strokeWidth={2} />
      </span>
    </Link>
  );
}
